import { apiClient } from './client'

export type FeedbackCategory = 'BUG' | 'FEATURE_REQUEST' | 'IMPROVEMENT' | 'OTHER'

/** What only the browser knows. The server adds the reporter, workspace, build and browser. */
export interface FeedbackClientContext {
  route: string
  locale: string
  viewport: string
}

export interface SubmitProductFeedbackRequest {
  category: FeedbackCategory
  title: string
  description: string
  /** Identified unless true. An anonymous item keeps its workspace but not its reporter. */
  anonymous: boolean
  context: FeedbackClientContext
}

export interface SubmitProductFeedbackResponse {
  id: string
  status: string
  createdAt: string
}

export const productFeedbackApi = {
  submit: (request: SubmitProductFeedbackRequest) =>
    apiClient.post<SubmitProductFeedbackResponse>('/api/v1/product-feedback', request),
}
